import { MenuLateral } from '@/components/shared/MenuLateral';
import { DetalhesEmenta } from '@/pages/DetalhesEmenta';
import { ComposicaoCG } from '@/pages/Graduacao/ComposicaoCG';
import { DisciplinasEletivas } from '@/pages/Graduacao/DisciplinasEletivas';
import { DisciplinasEmenta } from '@/pages/Graduacao/DisciplinasEmenta';
import { DisciplinasObrigatorias } from '@/pages/Graduacao/DisciplinasObrigatorias';
import { ListarSolicitacoesGraduacao } from '@/pages/Graduacao/ListarSolicitacoesGraduacao';
import { SolicitacoesGraduacao } from '@/pages/Graduacao/SolicitacoesGraduacao';

import { Route, Routes } from 'react-router-dom';


const AcademicoGraduacaoRoutes = () => {
    return (
        <div className='flex'>
            <MenuLateral
                title='Graduação - Acadêmico'
                menuType='feagri-graduacao-academi'
            />

            <div className='pl-10'>
                <Routes>
                    <Route path='/disciplinas/obrigatorias' element={<DisciplinasObrigatorias />} />
                    <Route path='/disciplinas/programa' element={<DisciplinasEmenta />} />
                    <Route path='/disciplinas/eletivas' element={<DisciplinasEletivas />} />
                    <Route path='/disciplinas/programa/:ano/:cod_disci' element={<DetalhesEmenta />} />

                    <Route path='/comissao/composicao-cg' element={<ComposicaoCG />} />


                    <Route path='/protocolo/solicitacoes' element={<SolicitacoesGraduacao />} />
                    <Route path='/protocolo/solicitacoes/listar' element={<ListarSolicitacoesGraduacao />} />
                </Routes>
            </div>
        </div>
    );
}

export { AcademicoGraduacaoRoutes };